import { ApiError } from '@/api/http/types'

export function compactRewardLabel(reward?: {
  enabled?: boolean
  amount?: number | null
  display?: string | null
} | null): string | null {
  if (!reward?.enabled) return null
  if (typeof reward.amount === 'number' && Number.isFinite(reward.amount)) {
    const rounded = Math.round(reward.amount * 100) / 100
    return Number.isInteger(rounded) ? `$${rounded}` : `$${rounded.toFixed(2)}`
  }
  const display = reward.display?.trim()
  return display || null
}

export function formatWelcomeDuration(minutes?: number | null): string | null {
  if (minutes == null || !Number.isFinite(minutes) || minutes < 1) return null
  const safe = Math.round(minutes)
  return safe === 1 ? '1 minute' : `${safe} minutes`
}

export function welcomeSubtitle(minutesLabel: string | null, rewardLabel: string | null): string {
  const duration = minutesLabel ? `About ${minutesLabel} total. ` : ''
  const browser = 'Complete the survey in your browser'
  if (rewardLabel) {
    return `${duration}${browser} and receive a ${rewardLabel} digital gift card when you finish.`
  }
  return `${duration}${browser}.`
}

export function isPublicSignupSurveyNotFound(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 404 || error.code === 'not_found')
}
